import BookingIcon from 'assets/images/icons/channels/booking.svg?react';
import SelectField from 'components/forms/selectField/SelectField';
import { Trans, useTranslation } from 'react-i18next';
import { typedEntries } from 'utils/funcs';
import { BOOKING_PERCENT_APPLIES_TO_OPTIONS } from './PropertyFeeModal.constants';
import { MappingTypeContainer } from './PropertyFeeModal.styles';

const BookingPercentAppliesToField = ({
  labelInputSizes,
}: {
  labelInputSizes: {
    colSmLabel: number;
    colSmInput: number;
  };
}) => {
  const { t } = useTranslation();

  const options = [
    {
      value: '',
      label: t('common.pleaseSelect'),
    },
    ...typedEntries(BOOKING_PERCENT_APPLIES_TO_OPTIONS).map(([, value]) => ({
      value,
      label: t(
        'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.channelSpecific.bookingPercentAppliesToOptions',
        {
          context: value,
        },
      ),
    })),
  ];

  return (
    <MappingTypeContainer className="has-right-tooltip">
      <SelectField
        name="bookingPercentAppliesTo"
        label={t(
          'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addModal.bookingPercentAppliesTo',
        )}
        {...labelInputSizes}
        options={options}
        rightTooltip={
          <Trans
            i18nKey="pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addModal.bookingPercentAppliesToTooltip"
            components={{
              1: (
                <a
                  href="https://partner.booking.com/en-gb/help/commission-invoices-tax/local-taxes/understanding-extra-charges"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Booking.com documentation"
                />
              ),
            }}
          />
        }
      />
      <BookingIcon />
    </MappingTypeContainer>
  );
};

export default BookingPercentAppliesToField;
